import { useMutation } from "react-query";
import signedDeclarationAI from "../services/signedDeclarationAI";

function useSignedDeclarationOfAI() {
  return useMutation(["signed-declaration-of-ai"], signedDeclarationAI);
}

export default useSignedDeclarationOfAI;
